import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '@environments/environment';
import { CompanyService } from '@app/shared/services/company.service';
import { IFBMyReferral, IFBPagedResponseHttp, IFBReferralFeedback } from '@interfaces';
import { Observable } from 'rxjs';
import { shareReplay } from 'rxjs/operators';
import { IFBStatistics } from '@app/models/statistics';

@Injectable({
  providedIn: 'root'
})
export class TalentScoutResource {
  url = `https://${this.companyService.subdomain}.${environment.REFERRAL_BASE}/api/talentscout`;

  private cache: { [key: string]: Observable<unknown> } = {};

  constructor(
    private companyService: CompanyService,
    private http: HttpClient
  ) {}

  declineReferral(token: string) {
    const url = `https://s${environment.API_BASE}/v1/companies/${this.companyService.data.id}/referrals/${token}`;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json;charset=utf-8'
    });
    return this.http.delete(url, { headers });
  }

  deleteReferral(id: string) {
    return this.http.delete(this.url + `/referrals/${id}`);
  }

  getReferrals(params: { offset?: number; limit: number; sort?: string }) {
    return this.http.get<IFBPagedResponseHttp<IFBMyReferral>>(this.url + '/referrals', { params });
  }

  getReferralFeedback(id: string) {
    const cacheKey = `getReferralFeedback-${id}`;

    if (!this.cache[cacheKey]) {
      this.cache[cacheKey] = this.http
        .get<IFBReferralFeedback>(this.url + `/referrals/${id}/feedback`)
        .pipe(shareReplay(1));
    }

    return this.cache[cacheKey];
  }

  getStatistics() {
    return this.http.get<IFBStatistics>(this.url + '/statistics');
  }

  saveReferralFeedback(id: string, params) {
    return this.http.post<IFBReferralFeedback>(this.url + `/referrals/${id}/feedback`, params);
  }

  createReferral(recaptchaToken: string, body: any) {
    const headers = recaptchaToken ? new HttpHeaders({ 'X-Recaptcha-Token': recaptchaToken }) : {};

    return this.http.post<IFBMyReferral>(`${this.url}/referrals`, body, { headers });
  }

  createShare(body: any) {
    return this.http.post<{ baseUrl: string; token: string }>(`${this.url}/share`, body);
  }

  createMultiJobShare(body: { jobs: string[]; shareType: string }) {
    const options = {
      headers: {
        Accept: 'application/json',
        'X-1brd-Host': this.companyService.x1brdHost
      }
    };
    return this.http.post<{ token: string }>(
      `https://webapp.${environment.SERVICES_BASE}/talentscout/api/jobs/share`,
      body,
      options
    );
  }
}
